import React from 'react';
import {BUYERS, TEAM} from "../../consts/tables";
import Alert from "../Alert";
import {getData, manageData} from "../../requests/CRUD";
import {addSpaceAfterComma, capitalizeAll, formatName, formatType} from "../../utils";
import {send1031BuyerEmail} from "../../requests/emailRequests";
import {dateUStoISO} from "../../date-converter";
import BuyerForm from "../BuyerForm/BuyerForm";

const dateProps = [
    'LAST_MODIFIED',
];

function convertFormToData(formData) {
    const data = {...formData};
    dateProps.filter(key => data[key]).forEach(key => {
        const str = dateUStoISO(data[key]);
        if (str !== false) {
            data[key] = str;
        }
    });
    return data;
}

export default class BuyerDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            paneIndex: 0,
            isBusy: null,
            error: null,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.saveData();
    }

    handleChange(key, value) {
        const data = {...this.state.data};
        data[key] = value;
        this.setState({data});
    }

    handleDropdownChange(data) {
        this.setState({data});
    }

    saveData() {
        if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
        });

        Object.keys(this.state.data).forEach(k => {
            if (!this.state.data[k] || k === 'undefined') {
                const newData = {...this.state.data};
                delete newData[k];
                this.setState({data: newData})
            }
        });

        Promise.all([
            manageData({
                tableCode: BUYERS,
                data: [convertFormToData(this.state.data)],
            }),
            getData({
                tableCode: TEAM,
                options: {
                    column: [
                        'FIRST_NAME',
                        'LAST_NAME',
                    ],
                    filter: [{
                        'text': this.state.data.STRIVE_AGENT ? this.state.data.STRIVE_AGENT : '',
                        'code': 'ARCIMEDES_ROW_ID',
                        'type': 'exact',
                    }],
                }
            })
        ]).then(res => {
            if (res && res[0] && res[0].success && res[1] && res[1].success) {
                this.setState({isBusy: false});
                this.props.savedNewItem(res[0].data[0]);

                if (this.props.closeDrawer) {
                    this.props.closeDrawer();
                    setTimeout(() => this.setState({data: {}}));
                }
            } else {
                this.setState({
                    isBusy: null,
                    error: res && res[0] && res[0].message ? res[0].message : 'Unspecified error',
                });
            }
            return {
                success: res[0].success && res[1].success,
                CATEGORY: capitalizeAll(res[0].data[0].CATEGORY),
                TYPE: formatType(res[0].data[0].TYPE),
                MARKET: capitalizeAll(res[0].data[0].MARKET),
                TENANT_SUBCATEGORY: res[0].data[0].TYPE === 'MT' ? addSpaceAfterComma(res[0].data[0].MULTI_TENANT_SUBCATEGORY) : res[0].data[0].TYPE === 'STNL' ? addSpaceAfterComma(res[0].data[0].SINGLE_TENANT_SUBCATEGORY) : null,
                PRICE_MIN: res[0].data[0].PRICE_MIN,
                PRICE_MAX: res[0].data[0].PRICE_MAX,
                CAP_RATE_MIN: res[0].data[0].CAP_RATE_MIN,
                CAP_RATE_MAX: res[0].data[0].CAP_RATE_MAX,
                STRIVE_AGENT: res[1].data.length ? formatName(res[1].data[0]) : null,
            }
        }).then(res => {
            if (res.success) {
                send1031BuyerEmail(res);
            }
        });
    }

    render() {
        const data = this.state.data;

        return (
            <div>
                <BuyerForm data={data}
                           paneIndex={this.state.paneIndex}
                           handleSubmit={this.handleSubmit}
                           handleCancel={this.props.closeDrawer}
                           handleParentChange={this.handleChange}
                           handleParentDropdownChange={this.handleDropdownChange}
                           handlePaneChange={(key) => this.setState({paneIndex: key})}/>
                {this.state.error && <Alert type='error'>{this.state.error}</Alert>}
            </div>
        )
    }
}